import Link, { type LinkProps } from 'next/link'
import type { AnchorHTMLAttributes } from 'react'

import { Tag, type TagProps } from './Tag'

export interface LinkTagProps
  extends Omit<TagProps, 'asChild' | 'children'>,
    LinkProps,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {}

export const LinkTag = ({ size, variant, children, className, ...rest }: LinkTagProps) => (
  <Tag size={size} variant={variant} active asChild>
    <Link {...rest}>{children}</Link>
  </Tag>
)
